import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Manufactured only: default production line for new orders of this product.
export function BomLineField({ value, onChange, machines }) {
  return (
    <div className="space-y-1.5">
      <Label>Production Line</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="bom-form-line"><SelectValue placeholder="Unassigned" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Unassigned</SelectItem>
          {machines.map((m) => <SelectItem key={m.id} value={m.id}>{m.line_code} · {m.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <p className="text-[10px] text-slate-400">New production orders for this product auto-assign to this line.</p>
    </div>
  );
}
